import React from "react";
import FeaturedSolutions from "./featured";
import FeaturedProcess from "./featured-process";
import FeatureSuccess from "./featured-success";
import FeatureClients from "./featured-clients";
import CookieConsent from "./cookie-consent";
import "./style.css";
import Particles from "react-particles-js";
import aviationDigitalTransformation from "../../assets/brochures/aviation_digital_brochure.pdf";

const styles = {
  btnCover: {
    padding: "20px 0",
    borderBottom: "1px solid #21212114",
  },
  btn: {
    padding: "8px 25px",
    borderColor: "#8c1922",
    color: "#8c1922",
  },
};
const particlesConfig = {
  particles: {
    number: {
      value: 20,
      density: {
        enable: true,
        value_area: 1000,
      },
    },
    color: {
      value: "#ffffff",
    },
    shape: {
      type: "star",
      stroke: {
        width: 0,
        color: "#000000",
      },
      polygon: {
        nb_sides: 5,
      },
      image: {
        src: "img/github.svg",
        width: 100,
        height: 100,
      },
    },
    opacity: {
      value: 0.5,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 3,
      random: true,
      anim: {
        enable: false,
        speed: 40,
        size_min: 0.1,
        sync: false,
      },
    },
    line_linked: {
      enable: true,
      distance: 150,
      color: "#ffffff",
      opacity: 0.4,
      width: 1,
    },
    move: {
      enable: true,
      speed: 6,
      direction: "none",
      random: false,
      straight: false,
      out_mode: "out",
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detect_on: "canvas",
    events: {
      onhover: {
        enable: true,
        mode: "repulse",
      },
      onclick: {
        enable: true,
        mode: "push",
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 400,
        line_linked: {
          opacity: 1,
        },
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 8,
        speed: 3,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
    },
  },
  retina_detect: true,
};

class HomePage extends React.Component {
  state = {
    scroll: false,
    overlay: "",
  };
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    if (window.scrollY > 40) {
      console.log("scrolling");
      this.setState({ scroll: true, overlay: "overlay" });
    }
    if (window.scrollY === 0) {
      console.log("stopped");
      this.setState({ scroll: false, overlay: "" });
    }
  };

  render() {
    return (
      <div>
        <div className="container-fluid no-pd">
          <div className="row">
            <div className="col-md-12 no-pd">
              <div>
                <div id={"site-banner"}>
                  <div className={this.state.scroll ? "overlay" : ""}></div>
                  <div id={"content"} className={"text-center"}>
                    <h3
                      className={""}
                      style={{ color: "#fff", fontSize: "2.2em" }}
                    >
                      {/* Providing Efficient Airport Operations <br />
                                        Through Automation Across Africa */}
                      Aviation Digital Transformation 2020 RoadMap
                    </h3>
                    <div className={"container"} style={styles.btnCover}>
                      <div className="row">
                        <div className="col-md-12">
                          <a
                            download
                            href={aviationDigitalTransformation}
                            className={"btn"}
                            style={{ background: "#8c1922", color: "white" }}
                          >
                            Download
                          </a>
                        </div>
                      </div>
                    </div>
                    {/* <Link to="/products" className='animated fadeInUp mt-2'>
                                        <Button color='default' >
                                            {/* Read More */}
                    {/* <a href={aviationDigitalTransformation}>Download</a> */}
                    {/* </Button> */}
                    {/* </Link> */} */}
                  </div>
                  <Particles height={"500px"} params={particlesConfig} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Featured solutions*/}
        <FeaturedSolutions />

        {/*Featured process*/}
        <FeaturedProcess />
        {/*Featured success */}
        <FeatureSuccess />
        {/*Featured clients */}
        <FeatureClients />

        <CookieConsent />
      </div>
    );
  }
}
export default HomePage;



// WEBPACK FOOTER //
// ./src/views/home/index.js